"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PARTIAL_VIEW_CONFIG_ELEMENT_ID = exports.CONFIG_ELEMENT_ID = void 0;
const CONFIG_ELEMENT_ID = exports.CONFIG_ELEMENT_ID = 'analytics-provider-data';
const PARTIAL_VIEW_CONFIG_ELEMENT_ID = exports.PARTIAL_VIEW_CONFIG_ELEMENT_ID = 'analytics-provider-data-partial';
